import { eventEmitter } from '@/event-bus'
import i18n from '@/i18n/i18n'
import ExportOrderDocumentsService from '@/services/admin/ExportOrderDocumentsService.js'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const actions = {
  toggleModal({ dispatch }) {
    eventEmitter.emit('toggle-export-order-documents-modal-event')
  },
  startExportDocumentProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      ExportOrderDocumentsService.startExportDocumentProcess(form)
        .then(response => {
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: t('views.admin.orders.index.export_documents')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.export_order_documents.exporting_process_failed_while_starting') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
